import fetch from "base/shared/fetch-data";
import envVars from "base/shared/Env";
import { getAPIUrl as getServerUrl } from "base/shared/Utils";

const fetchHomeCities = (
  token,
  isLoggedUser,
  countryCode,
  additionalParams,
) => {
  const { BADI_API_URL, BADI_HOME, BADI_HOME_CONTEXT } = envVars();

  const service = isLoggedUser ? BADI_HOME_CONTEXT : BADI_HOME;
  const params = countryCode ? { country_code: countryCode } : null;

  return fetch(BADI_API_URL + service, { params, token, additionalParams });
};

const sendForm = (token, params) => {
  const { BADI_FORM_LEADS } = envVars();
  const serverUrl = getServerUrl(BADI_FORM_LEADS);

  return fetch(serverUrl, {
    params,
    requiredParams: true,
    method: "POST",
    token,
  });
};

export { fetchHomeCities, sendForm };
